import _extends from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
var __jsx = React.createElement;
import AnalyticScript from '@anm/components/video-landings/AnalyticScript';
import Footer from '@anm/components/video-landings/Footer';
import { Wrapper } from './Wrapper';
import { injectFonts } from './helpers';
import useLayoutHeight from './hooks/useLayoutHeight';

var Layout = function Layout(_ref) {
  var _page$parameters;

  var _ref$hasFooter = _ref.hasFooter,
      hasFooter = _ref$hasFooter === void 0 ? true : _ref$hasFooter,
      page = _ref.page,
      children = _ref.children,
      viewType = _ref.viewType,
      footerStyles = _ref.footerStyles,
      _ref$isCustomization = _ref.isCustomization,
      isCustomization = _ref$isCustomization === void 0 ? false : _ref$isCustomization,
      wrapperProps = _objectWithoutProperties(_ref, ["hasFooter", "page", "children", "viewType", "footerStyles", "isCustomization"]);

  injectFonts({
    isCustomization: isCustomization,
    currentTheme: wrapperProps.variant
  });
  var layoutRef = useLayoutHeight({
    page: page,
    viewType: viewType,
    isCustomization: isCustomization
  });

  var _ref2 = (page === null || page === void 0 ? void 0 : (_page$parameters = page.parameters) === null || _page$parameters === void 0 ? void 0 : _page$parameters.track) || {},
      googleTrackId = _ref2.googleTrackId,
      facebookPixelTrackId = _ref2.facebookPixelTrackId;

  return __jsx(Wrapper, _extends({
    ref: layoutRef
  }, wrapperProps), children, hasFooter && __jsx(Footer, {
    fontStyles: footerStyles
  }), googleTrackId && __jsx(AnalyticScript, {
    id: googleTrackId,
    scriptType: "ga"
  }), facebookPixelTrackId && __jsx(AnalyticScript, {
    id: facebookPixelTrackId,
    scriptType: "fb"
  }));
};

export default Layout;